import React, { useState, useEffect } from 'react'
import './Footer.scss';
import { useLocation } from 'react-router-dom';
import { GoLocation } from "react-icons/go";
import { FiPhone } from "react-icons/fi";
import { TiDocumentText } from "react-icons/ti";
import { GoMail } from "react-icons/go";
import { GrApple, GrAppleAppStore, GrFacebookOption, GrGooglePlay } from "react-icons/gr";
import { TiSocialTwitter } from "react-icons/ti";
import { AiOutlineInstagram } from "react-icons/ai";
import { FansaLogo } from '../utils/icons';
import { getCategories, getProducts } from '../hooks/gets';
import * as _ from 'lodash'
import { firstCharCapitalize } from '../utils/utils';
import { scrollBodyTop } from '../hooks/scrollPosition';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux'
import { setAllProducts, setSelectedCategory, pushFilters, resetFilters, setPaginationState, setProductsTable, showSpinner } from '../actions'
import { CategoryFilter } from '../filters/CategoryFilter'
import { selectCategoryExpositor, selectCategoryImplantations, selectCategoryOutlet } from '../hooks/selectCategory';
import AppleStoreIcon from '../../img/boton-app-store.png';
import AndroidStoreIcon from '../../img/boton-play-store.png';
import { PopupOneButton } from './PopupOneButton';
import { BRANDCHOSEN, PreChangeBrandChosen } from '../hooks/config';

const Footer = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const footerInfoInit = {
        descripcion: [
            'Todos los estilos, los colores, los tamaños, los materiales para llenar de verde tu vida.',
            '¡Descubre la maceta para ti!'
        ],
        mapa: [
            { title: 'Productos', url: '/' },
            { title: 'Outlet', url: '/outlet' },
            // { title: 'Expositores & PLV', url: '/expositores' },
            { title: 'Implantaciones', url: '/implantaciones' }, //debug implantaciones descomentar
            { title: 'Empresa', url: '/empresa' },
            { title: 'Contacto', url: '/contacto' },
            { title: 'Descargas', url: '/catalogos' },
            { title: 'Política de privacidad', url: '/politica-de-privacidad' },
            { title: 'Política de cookies', url: '/politica-de-cookies' },
            { title: 'Aviso legal', url: '/aviso-legal' }
        ],
        categorias: [],
        contacto: {
            direccionL1: 'Carretera Entrena 38 26370',
            direccionL2: 'Navarrete La Rioja. España',
            telefono: '+34 941 44 00 00',
            fax: '+34 941 44 06 45',
            email: 'info@fansa.es'
        },
        redes: {
            faceURL: 'https://facebook.com',
            instaURL: 'https://instagram.com',
            twitterURL: 'https://twitter.com'
        }
    }

    const [footerInfo, setFooterInfo] = useState(null)
    const [showPopupPresupuestosPendientes, setShowPopupPresupuestosPendientes] = useState(false)

    useEffect(() => {
        getCategories().then(res => {
            footerInfoInit.categorias = res['fansa']
            setFooterInfo(footerInfoInit)
        }).catch(err => {
            console.log('err', err);
        })
    }, [])

    const goToMap = async (item) => {
        if (location.pathname !== item.url) {
            scrollBodyTop()
            if (item.title === 'Outlet') {
              changeBrandGlobal().then((res)=>{
                if(res == true) {
                  selectCategoryOutlet(props).then(res => {
                    navigate(item.url)
                  }).catch(err => {
                      console.log('err', err)
                  })
                }
              })
            } else if (item.title === 'Expositores & PLV') {
              changeBrandGlobal().then((res)=>{
                if(res == true) {
                  selectCategoryExpositor(props).then(res => {
                    navigate(item.url)
                  }).catch(err => {
                      console.log('err', err)
                  })
                }
              })
            } else if (item.title === 'Implantaciones') {
              changeBrandGlobal('scheurich').then((res)=>{
                if(res == true) {
                  selectCategoryImplantations(props).then(res => {
                    navigate(item.url)
                  }).catch(err => {
                      console.log('err', err)
                  })
                }
              })
            } else {
                navigate(item.url)
            }
        }
    }

    const changeBrandGlobal = (marca = 'fansa') => {
      return new Promise(async (resolve)=>{
        let marcaCambiada = await PreChangeBrandChosen(marca, props.budget)
        if(!marcaCambiada){
          setShowPopupPresupuestosPendientes(true)
          resolve(false)
        }else{
          resolve(true)
        }
      })
    }

    const goToCategory = async (item) => {
      changeBrandGlobal().then((res)=>{
        if(res == true) {
          if (props.selectedCategory !== item.ID || location.pathname.indexOf('/categoria/') === -1) {
              props.showSpinner(true)
              // if (props.productsTable !== 'allProducts') {
                  getProducts().then(res => {
                    console.log("Footer goToCategory, res=",res);
                      props.setAllProducts(res)
                      configCategory(item)
                  }).catch(err => {
                      props.showSpinner(false)
                  })
              // } else {
              //     configCategory(item)
              // }
          }
        }
      })
    }

    const configCategory = async (item) => {
        props.setPaginationState(1)
        props.setProductsTable('allProducts')
        const categoryFilter = new CategoryFilter(item.Name)
        await props.setSelectedCategory({
            categoryId: item.ID,
            subtitle: item.Name,
            img: item.ImgBanner,
            selectedCollection: ''
        })
        props.resetFilters()
        await props.pushFilters(categoryFilter)
        scrollBodyTop()
        const url = `/categoria/${item.ID}`
        navigate(url)
    }

    return (
      <div className="footer-container">
            {showPopupPresupuestosPendientes &&
                <PopupOneButton title="¡Presupuestos pendientes!" text="Tienes presupuestos pendientes, para cambiar de marca debes guardar o eliminar los presupuestos." textButton="Aceptar" onClick={() => setShowPopupPresupuestosPendientes(false)} />
            }
            {footerInfo !== null &&
                <div className="footer-content">
                    <div className="icon-text">
                        <div className="imagen-logo"><FansaLogo size={50} /></div>
                        {Array.isArray(footerInfo.descripcion) && footerInfo.descripcion.map((txt, i) => (
                            <p key={i}>{txt}</p>
                        ))}
                    </div>
                    <div className="mapa-cat-contact">
                        <div className="mapa-categorias">
                            <div className="mapa-sitio">
                                <div className="column-container">
                                    <div className="titulo">Mapa del sitio</div>
                                    {Array.isArray(footerInfo.mapa) && footerInfo.mapa.map((item, i) => (
                                        <div className="enlace pointer" key={i}>
                                            <p onClick={() => goToMap(item)}>{item.title}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="categorias">
                                <div className="column-container">
                                    <div className="titulo">Categorias</div>
                                    {Array.isArray(footerInfo.categorias) && footerInfo.categorias.map((item, i) => (
                                        <div className="enlace pointer" key={i}>
                                            <p onClick={() => goToCategory(item)}>{firstCharCapitalize(item.Name)}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="contacto-redes-sociales">
                            <div className="contacto">
                                <div className="titulo">Contacto</div>
                                <div className="data localizacion">
                                    <div className="icon"><GoLocation size={20} /></div>
                                    <div className="text">
                                        <p>{footerInfo.contacto.direccionL1}</p>
                                        <p>{footerInfo.contacto.direccionL2}</p>
                                    </div>
                                </div>

                                <div className="data">
                                    <div className="icon"><FiPhone size={20} /></div>
                                    <div className="text">
                                        <p>{footerInfo.contacto.telefono}</p>
                                    </div>
                                </div>

                                <div className="data">
                                    <div className="icon"><TiDocumentText size={20} /></div>
                                    <div className="text">
                                        <p>{footerInfo.contacto.fax}</p>
                                    </div>
                                </div>

                                <div className="data">
                                    <div className="icon"><GoMail size={20} /></div>
                                    <div className="text">
                                        <p>{footerInfo.contacto.email}</p>
                                    </div>
                                </div>

                            </div>
                            <div className="redes-sociales">
                                <div className="column-content">
                                    <div className="rs-container hidden">
                                        <a href={footerInfo.redes.faceURL}><GrFacebookOption size={20} /></a>
                                    </div>
                                    <div className="rs-container hidden">
                                        <a href={footerInfo.redes.twitterURL}><TiSocialTwitter size={20} /></a>
                                    </div>
                                    <div className="rs-container hidden">
                                        <a href={footerInfo.redes.instaURL}><AiOutlineInstagram size={20} /></a>
                                    </div>
                                    <div className="rs-container store">
                                        <a target="_blank" href="https://apps.apple.com/us/app/fansa/id1545551639"><img src={AppleStoreIcon} alt="" /></a>
                                    </div>
                                    <div className="rs-container store">
                                        <a target="_blank" href="https://play.google.com/store/apps/details?id=online.proyecto.fansa"><img src={AndroidStoreIcon} alt="" /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

const mapStateToProps = state => state

const mapDispatchToProps = {
    setAllProducts,
    setSelectedCategory,
    pushFilters,
    resetFilters,
    setProductsTable,
    setPaginationState,
    showSpinner
}

export default connect(mapStateToProps, mapDispatchToProps)(Footer)